import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import PropTypes from 'prop-types';
import './VirtualTryOn.scss';

/**
 * Minimalistic Virtual Try-On Button
 * Appears in top-right corner of product images for fashion items
 * Toggles menu when clicked
 */
const VirtualTryOnButton = ({
  likiee,
  onTryOnClick,
  disabled = false,
  className = '',
  isShowingTryOn = false,
  isGenerating = false,
  isMenuOpen = false,
}) => {
  const { t } = useTranslation();

  // Check if this is a fashion product
  const isFashion = likiee?.aiSummary?.imageType === 'fashion';

  // Don't render button if not a fashion product
  if (!isFashion) {
    return null;
  }

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || isGenerating) return;

    if (onTryOnClick) {
      onTryOnClick();
    }
  };

  const buttonText = isShowingTryOn ? (isMenuOpen ? '' : t('Menu')) : t('Try on you');
  const creditCost = 5; // Virtual try-on costs 10 credits
  const showCreditCost = !isShowingTryOn; // Only show credits on initial try-on button

  return (
    <button
      className={`virtual-tryon-button-corner ${isGenerating ? 'is-generating' : ''} ${
        isMenuOpen ? 'menu-open' : ''
      } ${className}`}
      onClick={handleClick}
      disabled={disabled || isGenerating}
      type='button'
      aria-label={buttonText || t('Virtual Try-On')}
    >
      <Sparkles className='virtual-tryon-button-corner__icon' size={18} />
      {buttonText && <span className='virtual-tryon-button-corner__text'>{buttonText}</span>}
      {showCreditCost && (
        <span className='credit-cost'>
          {creditCost} {creditCost !== 1 ? 'credits' : 'credit'}
        </span>
      )}
    </button>
  );
};

VirtualTryOnButton.propTypes = {
  likiee: PropTypes.shape({
    aiSummary: PropTypes.shape({
      imageType: PropTypes.string,
    }),
  }),
  onTryOnClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  isShowingTryOn: PropTypes.bool,
  isGenerating: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
};

export default VirtualTryOnButton;
